import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_COURSE_TYPES_MUTATION } from '../graphql/mutations'
import { transformToSaveCourseTypesArgs } from '../graphql/transformers'
import { SAVE_COURSE_TYPES } from '../redux/action-types'

const useSaveCourseTypesMutation = refetchLastEvent => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(
    store => store.courseTypes.courseTypes,
  )

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_COURSE_TYPES_MUTATION,
        { data: transformToSaveCourseTypesArgs(data) },
        dispatch,
        SAVE_COURSE_TYPES,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveCourseTypesMutation
